export default __webpack_public_path__ + "static/featured-24d8c7c4733b9b6771dcdb05fa2bc519.png";